import NavigationBar from "../navigation/nav-bar/navigationBar";
import AboutHelperComponent from "./aboutHelperComponent";
import FooterComponent from "../navigation/footer/footerComponent";


export default function About() {

    return (
        <div>
            <NavigationBar />
            <AboutHelperComponent />
            <FooterComponent />
        </div>
    )
}